
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/questions-and-answers/[questionSlug]",
      function () {
        return require("private-next-pages/questions-and-answers/[questionSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/questions-and-answers/[questionSlug]"])
      });
    }
  